import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-purple-700 text-white relative overflow-hidden"
               style={{
                 backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20office%20building%20with%20team%20of%20diverse%20professionals%20working%20together%2C%20Nagpur%20cityscape%20background%2C%20startup%20company%20atmosphere%2C%20purple%20and%20white%20corporate%20theme%2C%20professional%20business%20photography%2C%20success%20and%20growth%20concept&width=1200&height=600&seq=about-hero&orientation=landscape')`,
                 backgroundSize: 'cover',
                 backgroundPosition: 'center'
               }}>
        <div className="absolute inset-0 bg-purple-600/80"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              About BNM
            </h1>
            <p className="text-xl mb-8">
              A Nagpur-based startup redefining how families access home services
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16" id="mission">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-flag-line text-2xl text-purple-600"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Mission</h2>
              <p className="text-lg text-gray-600">
                Simplify everyday life by connecting customers with trusted service providers, making home services accessible, reliable, and convenient for every household.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-2xl text-blue-600"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Vision</h2>
              <p className="text-lg text-gray-600">
                Build India's most reliable on-demand service ecosystem – empowering homes with quality services and workers with sustainable income opportunities.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Timeline */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Journey</h2>
            <p className="text-xl text-gray-600">From idea to impact</p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="relative">
              <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-purple-200"></div>
              
              <div className="space-y-12">
                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0 w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg">
                    2023
                  </div>
                  <div className="flex-1 bg-purple-50 rounded-xl p-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Founded</h3>
                    <p className="text-gray-600">
                      BNM was founded in Nagpur with a vision to revolutionize home services. Our team identified the gap between service demand and reliable supply in the market.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0 w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg">
                    2024
                  </div>
                  <div className="flex-1 bg-blue-50 rounded-xl p-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Launched</h3>
                    <p className="text-gray-600">
                      Official launch of BNM platform with customer and partner apps. Started operations in Nagpur with a focus on quality service delivery and partner verification.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0 w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-lg">
                    2025
                  </div>
                  <div className="flex-1 bg-green-50 rounded-xl p-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Expanding</h3>
                    <p className="text-gray-600">
                      Expanding operations across multiple cities in Maharashtra and beyond. Scaling our technology platform and partner network to serve more households.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 bg-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Values</h2>
            <p className="text-xl text-gray-600">What drives us every day</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white rounded-xl p-8 text-center shadow-sm">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Trust & Safety</h3>
              <p className="text-gray-600">
                Every partner is thoroughly verified to ensure customer safety and service quality
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 text-center shadow-sm">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Empowerment</h3>
              <p className="text-gray-600">
                We empower service providers with technology, training, and steady income opportunities
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 text-center shadow-sm">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Innovation</h3>
              <p className="text-gray-600">
                Continuous improvement of our platform to deliver better experiences for all users
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/* <section className="py-16 bg-white" id="team">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Team</h2>
            <p className="text-xl text-gray-600">Passionate professionals driving change</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="w-32 h-32 bg-purple-100 rounded-full mx-auto mb-4 overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=professional%20business%20leader%20portrait%2C%20confident%20CEO%20or%20founder%2C%20modern%20corporate%20headshot%2C%20purple%20background%2C%20success%20and%20leadership%20concept%2C%20clean%20professional%20photography&width=300&height=300&seq=team-1&orientation=squarish" 
                     alt="Founder" 
                     className="w-full h-full object-cover object-top" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Priya Sharma</h3>
              <p className="text-purple-600 mb-2">Founder & CEO</p>
              <p className="text-gray-600 text-sm">
                Ex-tech executive with 10+ years experience in building scalable platforms
              </p>
            </div>

            <div className="text-center">
              <div className="w-32 h-32 bg-blue-100 rounded-full mx-auto mb-4 overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=professional%20technology%20executive%20portrait%2C%20CTO%20or%20tech%20leader%2C%20modern%20corporate%20headshot%2C%20blue%20background%2C%20innovation%20and%20technology%20concept%2C%20clean%20professional%20photography&width=300&height=300&seq=team-2&orientation=squarish" 
                     alt="CTO" 
                     className="w-full h-full object-cover object-top" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Rajesh Kumar</h3>
              <p className="text-blue-600 mb-2">Co-founder & CTO</p>
              <p className="text-gray-600 text-sm">
                Technology expert specializing in mobile app development and AI solutions
              </p>
            </div>

            <div className="text-center">
              <div className="w-32 h-32 bg-green-100 rounded-full mx-auto mb-4 overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=professional%20operations%20manager%20portrait%2C%20COO%20or%20operations%20leader%2C%20modern%20corporate%20headshot%2C%20green%20background%2C%20efficiency%20and%20operations%20concept%2C%20clean%20professional%20photography&width=300&height=300&seq=team-3&orientation=squarish" 
                     alt="COO" 
                     className="w-full h-full object-cover object-top" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Anjali Desai</h3>
              <p className="text-green-600 mb-2">Head of Operations</p>
              <p className="text-gray-600 text-sm">
                Operations specialist ensuring smooth service delivery across all locations
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Impact Numbers */}
      <section className="py-16 bg-purple-600 text-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Our Impact</h2>
            <p className="text-xl">Making a difference in the community</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">10,000+</div>
              <p className="text-purple-100">Happy Customers</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">2,500+</div>
              <p className="text-purple-100">Verified Partners</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">50,000+</div>
              <p className="text-purple-100">Services Completed</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">15+</div>
              <p className="text-purple-100">Service Categories</p>
            </div>
          </div>
        </div>
      </section>

      {/* Download Apps Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Download Our Apps</h2>
          <p className="text-xl text-gray-600 mb-12">Available on Google Play & App Store</p>
          
         <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
  {/* Customer App Card */}
  <div className="bg-white rounded-xl p-8 shadow-sm">
    <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <i className="ri-smartphone-line text-2xl text-purple-600"></i>
    </div>
    <h3 className="text-xl font-semibold text-gray-800 mb-4">Customer App</h3>
    <p className="text-gray-600 mb-6">Book services in seconds</p>
    <div className="flex flex-col gap-3">
      <a
        href="https://play.google.com/store/apps/details?id=com.baainearme.customerapp"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
      >
        <i className="ri-google-play-fill mr-2 text-lg"></i>
        Android
      </a>
      <a
        href="https://apps.apple.com/app/bnm/id6751604989"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
      >
        <i className="ri-app-store-fill mr-2 text-lg"></i>
        iOS
      </a>
    </div>
  </div>

  {/* Partner App Card */}
  <div className="bg-white rounded-xl p-8 shadow-sm">
    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <i className="ri-tools-line text-2xl text-green-600"></i>
    </div>
    <h3 className="text-xl font-semibold text-gray-800 mb-4">Partner App</h3>
    <p className="text-gray-600 mb-6">Accept jobs & earn</p>
    <div className="flex flex-col gap-3">
      <a
        href="https://play.google.com/store/apps/details?id=com.baainearme.partnerapp"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
      >
        <i className="ri-google-play-fill mr-2 text-lg"></i>
        Android
      </a>
      <a
        href="https://apps.apple.com/app/bnm-partner/id6751844889"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
      >
        <i className="ri-app-store-fill mr-2 text-lg"></i>
        iOS
      </a>
    </div>
  </div>
</div>

        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-white" id="contact">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Get in Touch</h2>
            <p className="text-xl text-gray-600">We'd love to hear from you</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Visit Us</h3>
              <p className="text-gray-600">
                BNM Headquarters<br />
                Nagpur, Maharashtra<br />
                India
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Call Us</h3>
              <p className="text-gray-600">
                📞 93074 19845<br />
                Mon-Sat: 9 AM - 6 PM
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Email Us</h3>
              <p className="text-gray-600">
                ✉ support@baainearme.com<br />
                We reply within 24 hours
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              {/* BNM logo (SVG) — scalable, color via currentColor */}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 420 160"
  className="h-10 text-white"   // change to text-purple-600 etc.
  role="img"
  aria-label="BNM · Baainearme"
>
  <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round">
    {/* Left ring */}
    <circle cx="50" cy="60" r="40" />
    {/* Vertical divider */}
    <line x1="110" y1="20" x2="110" y2="120" />
  </g>

  {/* Text block */}
  <g fill="currentColor">
    {/* BNM */}
    <text
      x="140"
      y="72"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="800"
      fontSize="56"
    >
      BNM
    </text>

    {/* Baainearme */}
    <text
      x="140"
      y="120"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="700"
      fontSize="32"
    >
      Baainearme
    </text>
  </g>
</svg>

              <p className="text-gray-400">
                Redefining how families access home services across India
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/customer" className="hover:text-white cursor-pointer">For Customers</Link></li>
                <li><Link to="/partner" className="hover:text-white cursor-pointer">For Partners</Link></li>
                <li><Link to="/careers" className="hover:text-white cursor-pointer">Careers</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Press</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/press" className="hover:text-white cursor-pointer">Press Releases</Link></li>
                <li><Link to="/ads" className="hover:text-white cursor-pointer">Ads and Marketing</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Legal</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/customer-terms" className="hover:text-white cursor-pointer">Terms & Conditions</Link></li>
                <li><Link to="/customer-privacy" className="hover:text-white cursor-pointer">Privacy Policy</Link></li>
                <li><Link to="/refund-policy" className="hover:text-white cursor-pointer">Refund Policy</Link></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
